import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { APP_ROUTES } from '@core/constants';
import { AuthService } from '@core/services';
import { map, tap } from 'rxjs';

export const roleAuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router: Router = inject(Router);
  const authService: AuthService = inject(AuthService);

  const baseUrl = state.url
    .split('?')[0]
    .replace(/^\//, '')
    .replace(/\/\d+/g, '');
  const roles = route.data['roles'];
  const rolesAI = route.data['rolesAI'];

  return authService.checkRole(baseUrl, roles, rolesAI).pipe(
    tap((hasRole) => {
      if (!hasRole) {
        void router.navigate([APP_ROUTES.ERROR]);
      }
    }),
    map((hasRole) => hasRole)
  );
};
